import { HeroSection } from '../components/HeroSection';
import { USPSection } from '../components/USPSection';
import { BentoSection } from '../components/BentoSection';
import { StatsSection } from '../components/StatsSection';
import { ServicesSection } from '../components/ServicesSection';
import { ContactSection } from '../components/ContactSection';
import { BrandVideoSection } from '../components/BrandVideoSection';
import SEOHead from '../components/SEOHead';

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <SEOHead path="/" />
      <HeroSection />
      <USPSection />
      <BentoSection />
      <StatsSection />
      <BrandVideoSection />
      <ServicesSection />
      <ContactSection />
    </main>
  );
}
